import { ApiLinkEntity, ApiLinkRel } from "config/constants";
import { Guid, IApiLink } from "@/types";
import i18n from "intl/i18n"

export enum WeekDay {
    monday = "monday",
    tuesday = "tuesday",
    wednesday = "wednesday",
    thursday = "thursday",
    friday = "friday",
    saturday = "saturday",
    sunday = "sunday"
}

export interface IGetWorkingDaysCalendarDto {
    id: Guid
    description: string
    workingDaysPerMonth: number
    weekDays: WeekDay[]
    holidayIds: Guid[]
    links: IApiLink[]
}

export interface ICreateUpdateWorkingDaysCalendarDto {
    description: string
    workingDaysPerMonth: number
    weekDays: WeekDay[]
    holidayIds: Guid[]
}

export default class WorkingDaysCalendar {
    id: Guid
    description: string
    workingDaysPerMonth: number
    weekDays: WeekDay[]
    holidayIds: Guid[]
    linkUpdate?: IApiLink

    constructor(dto: IGetWorkingDaysCalendarDto) {
        this.id = dto.id
        this.description = dto.description
        this.workingDaysPerMonth = dto.workingDaysPerMonth
        this.weekDays = dto.weekDays
        this.holidayIds = dto.holidayIds
        this.linkUpdate = dto.links.find(link => link.entity === ApiLinkEntity.workingDaysCalendar && link.rel === ApiLinkRel.update)
    }
}

export function getWeekdayShort(weekDay: WeekDay) {
    return i18n.t(`weekDaysShort.${weekDay}`)
}
